<div
    class="flex flex-col px-10 py-4 border-2 rounded-md"
    [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'"
>
    <div class="text-lg font-semibold my-1">
        {{ title() }}
        @if (optional()) {
            <span class="italic text-xs font-light">neobavezno</span>
        }
    </div>

    <div class="valben-calendar-shell mt-3 w-80 max-w-full overflow-hidden rounded-xl border border-slate-200 bg-white">
        <div class="grid grid-cols-2 border-b border-slate-200 bg-slate-50" aria-live="polite">
            <div class="border-r border-slate-200 px-4 py-3">
                <div class="text-xs font-semibold text-slate-500">Datum početka</div>
                <div class="mt-1 min-h-5 text-sm font-semibold text-slate-800">
                    {{ startDate() ? (startDate() | date: "dd.MM.yyyy.") : "Odaberite datum" }}
                </div>
            </div>
            <div class="px-4 py-3">
                <div class="text-xs font-semibold text-slate-500">Datum završetka</div>
                <div class="mt-1 min-h-5 text-sm font-semibold text-slate-800">
                    {{ endDate() ? (endDate() | date: "dd.MM.yyyy.") : "Odaberite datum" }}
                </div>
            </div>
        </div>

        <div class="px-4 pt-3 text-xs font-medium text-slate-500">
            {{ selectingEnd() ? "Odaberite datum završetka." : "Odaberite datum početka." }}
        </div>

        <mat-calendar
            class="valben-admin-calendar w-full"
            [selected]="selectedRange()"
            [startAt]="startAt()"
            [minDate]="minDate() ?? null"
            [maxDate]="maxDate() ?? null"
            startDateAccessibleName="Datum početka"
            endDateAccessibleName="Datum završetka"
            (selectedChange)="onSelect($event)" />

        <div class="flex items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-4 py-3">
            @if (showTodayButton()) {
                <button
                    type="button"
                    class="valben-calendar-action valben-calendar-action--primary"
                    (click)="setToday()"
                    aria-label="Odaberi današnji datum"
                >
                    Danas
                </button>
            }
            <button
                type="button"
                class="valben-calendar-action"
                (click)="onClear()"
                aria-label="Očisti datum početka i završetka"
            >
                Očisti
            </button>
        </div>
    </div>
</div>
